import {HttpStatusCode} from 'axios';
import {
  RebookBookingRequestDto,
  DisplayMessage,
  Result,
  CancelBookingRequest,
  CreateCustomBookingRequest,
  CreateBookingRequest,
  CreateBooking,
} from '../lib/interfaces';
import {
  cancelBookingApi,
  createBookingWeddingOccasionApi,
  createCustomBookingWeddingOccasionApi,
  getMyBookingsApi,
  rebookBookingApi,
} from './apiServices';
import {DisplayMessageTypes} from '../lib/enums';
import {t} from 'i18next';

export async function createBooking(data: CreateBooking): Promise<Result<any, DisplayMessage>> {
  let response;
  if (data.isCustomOccasion) {
    response = await createCustomBookingWeddingOccasionApi({
      time: data.customBookingCreateDetails.time,
      address: data.customBookingCreateDetails.address,
      city: data.customBookingCreateDetails.city,
      weddingOfficiantId: data.customBookingCreateDetails.weddingOfficiantId,
      booking: {
        person1: data.person1,
        person2: data.person2,
        language: Number.parseInt(data.ceremonyLanguage),
        actor: data.actor,
      },
    } as CreateCustomBookingRequest);
  } else {
    response = await createBookingWeddingOccasionApi({
      weddingOccasionId: data.weddingOccasionId,
      person1: data.person1,
      person2: data.person2,
      language: Number.parseInt(data.ceremonyLanguage),
      actor: data.actor,
    } as CreateBookingRequest);
  }

  if (response.status === HttpStatusCode.Created) {
    return {
      data: response.data,
      info: null,
    } as Result<any, DisplayMessage>;
  } else {
    return {
      data: null,
      info: {type: DisplayMessageTypes.Error, message: response.message},
    } as Result<any, DisplayMessage>;
  }
}

export async function getMyBookings(personalIdentityNumber: string): Promise<Result<any, DisplayMessage>> {
  const response = await getMyBookingsApi(personalIdentityNumber);
  if (response.status === HttpStatusCode.Ok) {
    return {
      data: response.data,
      info: null,
    } as Result<any, DisplayMessage>;
  } else {
    return {
      data: null,
      info: {type: DisplayMessageTypes.Error, message: response.message},
    } as Result<any, DisplayMessage>;
  }
}

export async function cancelBooking(bookingId: string, actor: string): Promise<Result<string, DisplayMessage>> {
  const response = await cancelBookingApi({bookingId, actor} as CancelBookingRequest);
  if (response.status === HttpStatusCode.Created) {
    return {
      data: response.data,
      info: {
        visible: true,
        type: DisplayMessageTypes.Success,
        message: t('message.bookingCanceled'),
      } as DisplayMessage,
    } as Result<string, DisplayMessage>;
  } else {
    return {
      data: null,
      info: {type: DisplayMessageTypes.Error, message: t('message.bookingCouldNotBeDeleted')} as DisplayMessage,
    } as Result<string, DisplayMessage>;
  }
}

export async function rebookBooking(
  bookingId: string,
  targetWeddingOccasionId: string,
  actor: string
): Promise<Result<string, DisplayMessage>> {
  const response = await rebookBookingApi({
    bookingId,
    targetWeddingOccasionId,
    actor,
  } as RebookBookingRequestDto);

  if (response.status === HttpStatusCode.Ok) {
    return {
      data: response.data,
      info: null,
    } as Result<string, DisplayMessage>;
  } else {
    return {
      data: null,
      info: {type: DisplayMessageTypes.Error, message: response.message},
    } as Result<string, DisplayMessage>;
  }
}
